import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/ir35_faqs.json";

export const useIR35FAQs = () => useSourceFlowCollection(data);

export default useIR35FAQs;
